import { Component, Input, OnChanges } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';

import { MESSAGE_COMMON_ERROR, MESSAGE_EDIT_SUCCESS } from '../../shared/message';
import { Course } from '../shared/course';
import { CourseService } from '../shared/course.service';

@Component({
  selector: 'app-course-billing-button',
  templateUrl: './course-billing-button.component.html'
})
export class CourseBillingButtonComponent implements OnChanges {
  @Input() course: Course;
  billing: boolean;

  constructor(private snackBar: MatSnackBar, private courseService: CourseService) { }

  ngOnChanges() {
    if (this.course) {
      const course: Course = Object.assign(new Course(), this.course);
      this.billing = course.isBilling();
    }
  }

  onChange(value: boolean, event) {
    if (this.course.billing !== value) {
      const changedCourse: Course = Object.assign(new Course(), this.course);
      changedCourse.changeBilling(value);
      this.onSubmit(changedCourse);
    }
  }

  async onSubmit(changedCourse: Course) {
    delete changedCourse.ownerObservable;
    try {
      this.courseService.update(this.course.$key, changedCourse);
      this.openSnackBar(MESSAGE_EDIT_SUCCESS);
    } catch (e) {
      this.openSnackBar(MESSAGE_COMMON_ERROR);
    }
  }

  private openSnackBar(message: string, action?: string, config?: MatSnackBarConfig) {
    config = Object.assign(new MatSnackBarConfig(), config, { duration: 3000 });
    this.snackBar.open(message, action, config);
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/courses/course-billing-button/course-billing-button.component.ts